@let viewModel = bannerViewModel();
@if (isComparisonActive() && viewModel) {
    <div class="comparisonBanner" [class.version-mode]="viewModel.mode === 'version'" [class.channel-mode]="viewModel.mode === 'channel'">
        <div class="badges">
            @for (badge of viewModel.badges; track badge.type) {
                <span
                    class="badge"
                    [class.stale]="badge.type === 'stale'"
                    [class.newSnapshot]="badge.type === 'newSnapshot'"
                    [class.clickable]="badge.clickable"
                    (click)="badge.clickable ? handleNewSnapshotBadgeClick() : null"
                    >{{ badge.labelKey | translate }}</span
                >
            }
        </div>

        <i class="far fa-code-compare"></i>
        <span class="explainer">{{ viewModel.explainerText }}</span>

        <button class="button small primary exitButton" type="button" (click)="handleExitComparisonClick()">
            <i class="far fa-arrow-left"></i>
            <span>{{ 'listing.version.backToEditMode' | translate }}</span>
        </button>
    </div>
}
